module.exports = __webpack_public_path__ + "img/target2.91301e3c.png";